import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Input,
  ButtonSecondary,
  FormDashboardInputPassword,
} from "../../../components";
import { resetPassword, setPopupContent } from "../../../features/account/slice";
import { formUpdater, useViewport } from "../../../utils";

const buttonText = {
  en: 'Submit new password',
  id: 'Kirim password baru'
}

const newPasswordPlaceholder = {
  en: 'New Password',
  id: 'Password Baru'
}

const FormReset = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form, setForm] = React.useState({});
  const { isMobile } = useViewport();
  // const translation = useSelector((state) => state.translation.data);
  const language = useSelector((state) => state.system.language);
  const [requesting, setRequesting] = React.useState(false);

  const updateForm = (e) => formUpdater(e, form, setForm);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(form);

    setRequesting(true);

    dispatch(resetPassword(form))
      .then((res) => {
        const message = res.payload?.message;
        toast.success(message);

        if(props.noRedirect){
          dispatch(setPopupContent('login'))
        } else {
          history.replace('/login')
        }
      })
      .catch((err) => {
        toast.error(err);
      })
      .finally(() => {
        setRequesting(false);
      });
  };

  return (
    <form {...props} onSubmit={handleSubmit}>
      <Input
        required
        placeholder="OTP"
        className="w-full mb-4"
        type="text"
        name="otp"
        onChange={updateForm}
      />
      <div className="mb-6 md:mb-8">
        <FormDashboardInputPassword
          required
          name="password"
          placeholder={newPasswordPlaceholder[language.name]}
          className="w-full py-4"
          onChange={updateForm}
        />
      </div>
      <ButtonSecondary
        isLoading={requesting}
        disabled={requesting}
        thin={isMobile}
        type="submit"
      >
        {buttonText[language.name]}
      </ButtonSecondary>
    </form>
  );
};

export { FormReset };
